module.exports = __webpack_public_path__ + "static/img/9-1.9267c5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/9-1.jpg
// module id = 2uV1
// module chunks = 0